import componentMixin from "./component-mixin.js";

// Handles Common components paterns
export default {
  mixins: [componentMixin],
  data() {
    return { value: null, model_group: [] };
  },
  created() {
    this.$store.getters.testParams[this.model]
      ? (this.value = this.$store.getters.testParams[this.model])
      : (this.value = this.default);
      },
  watch: {
    value: function (value) {
      this.$store.commit("setParam", { param: this.model, value });
      this.attributes.list_display
        ? this.$store.commit("setSelected", { param: this.model, value })
        : "";
    },
  },
  methods: {
    update_selected() {
      var previous_selected = this.if_selected;
      this.is_selected()
        ? (this.if_selected = "")
        : (this.if_selected = "d-none");

      !this.is_selected()
        ? ""
        : (this.$store.getters.listSelected[this.model] = this.value);

      if (this.attributes.list_display && !this.attributes.model_dependance) {
        this.if_selected = "";
      }
      if ((previous_selected === "d-none") & (this.if_selected === "")) {
        this.$store.commit("setParam", {
          param: this.model,
          value: this.value,
        });
      }
    },

    is_selected() {
      var result = true;
      for (var i in this.id_selected_tab) {
        this.$store.getters.listSelected[this.id_selected_tab[i]] ==
        this.model_dependance_tab[i]
          ? ""
          : (result = false);
      }
      return result;
    },
  },
  computed: {
    id_selected_tab() {
      if (this.attributes.id_selected === undefined) return [];
      else return this.attributes.id_selected.split("|");
    },
    model_dependance_tab() {
      if (this.attributes.model_dependance === undefined) return [];
      else return this.attributes.model_dependance.split("|");
    },
    disabled() {
      return (
        this.$store.state.player.isStarted &&
        !(
          this.$store.getters.progress === this.$store.getters.duration &&
          this.$store.getters.progress > 0
        )
      );
    },

    default() {
      return this.attributes.default || "";
    },
    help_key() {
      return `${this.$store.getters.experienceIdentifier}_${this.model}_help`;
    },
    label() {
      return this.attributes.label || "";
    },
    model() {
      return this.attributes.model || "";
    },
    model_dependance() {
      return this.attributes.model_dependance || "";
    },
    param() {
      return this.attributes.param || "";
    },
    title_component() {
      return this.attributes.title_component || "";
    },
    type_component() {
      return this.attributes.type_component || "";
    },
    pips_slider() {
      return this.attributes.pips ? this.attributes.pips : false;
    },
  },
};
